import { Header } from './common/Header';
import { Navbar } from './common/Navbar';
import { SpinLoading } from './common/SpinLoading';
import { SpinLoadingProvider } from '@/utils/context/spinLoading/SpinLoadingProvider';
import AlphaDisclaimer from './Disclaimer/AlphaDisclaimer';
import { DisclaimerProvider } from '@/utils/context/disclaimer/DisclaimerProvider';
import OnboardingIcon from './onboarding/OnboardingIcon';
import OnboardingModal from './onboarding/OnboardingModal';
import { OnboardingProvider } from '@/utils/context/Onboarding/OnboardingProvider';
import { useList } from '@refinedev/core';
import { SpinLoadingIcon } from './ui/SpinLoadingIcon';
import { useEffect, useState } from 'react';
import { MultipleTenants } from './multiple-tenant/MultipleTenants';
import { TenantDto } from '@/utils/company/dtos/TenantDto';
import { AccountCreatedMessage } from './common/AccountCreatedMessage';
import { captureAppException, captureAppMessage, getHttpErrorContext } from '@/utils/sentry/sentryLogger';

const Layout = ({ children }) => {
  const [isSelectedTenant, setIsSelectedTenant] = useState(false);
  const { data, isLoading, isError, error } = useList<TenantDto>({
    resource: 'Tenants',
    queryOptions: {
      onError: (fetchError) => {
        captureAppException(fetchError, {
          flow: 'app-startup',
          resource: 'Tenants',
          ...getHttpErrorContext(fetchError),
        });
      },
    },
  });
  const tenants = data?.data.sort((a, b) => a.name.localeCompare(b.name)) || [];
  useEffect(() => {
    if (data && !isLoading) {
      localStorage.setItem('Tenants', JSON.stringify(data.data));
      if (data.data.length === 0) {
        captureAppMessage('No tenants returned for user', 'warning', {
          flow: 'app-startup',
          resource: 'Tenants',
        });
      }
    }
  }, [data, isLoading]);

  if (isLoading) {
    return (
      <div className="flex min-h-screen w-screen flex-col items-center justify-center  text-[30px]">
        <div>
          <img src="/logos/growdata-logo-ops-product-dark-green-onwhite.png" alt="Growdata logo" width={480} />
        </div>
        <SpinLoadingIcon />
      </div>
    );
  }

  if (isError && error?.response?.status === 403) {
    return <AccountCreatedMessage />;
  }
  if (tenants.length === 1) {
    localStorage.setItem('TENANT_ID', String(tenants[0].id));
  }
  return (
    <div className="flex h-full w-screen">
      {tenants?.length > 1 && !isSelectedTenant ? (
        <div className="m-auto">
          <MultipleTenants tenants={tenants} setIsSelectedTenant={setIsSelectedTenant} />
        </div>
      ) : (
        <div className="flex h-full w-screen">
          <Navbar />
          <DisclaimerProvider>
            <AlphaDisclaimer />
            <OnboardingProvider>
              <OnboardingIcon />
              <OnboardingModal />
              <div className="flex w-full flex-col gap-[35px] ">
                <Header setIsSelectedTenant={setIsSelectedTenant} />
                <SpinLoadingProvider>
                  <div className="overflow-y-auto">{children}</div>

                  <SpinLoading />
                </SpinLoadingProvider>
              </div>
            </OnboardingProvider>
          </DisclaimerProvider>
        </div>
      )}
    </div>
  );
};

export default Layout;
